import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import trainingProgramsActionCreators from '../../store/training-programs/action-creators';
import TrainingProgramTable from './TrainingProgramTable';

const TrainingProgramIndex = (props) => {
  // ----------------------
  // Render
  // ----------------------

  return (
    <Fragment>
      <div className="app-content-header">
        <h4 className="title">Training Programs</h4>
      </div>
      <div className="app-content">
        <TrainingProgramTable trainingPrograms={props.trainingPrograms} />
      </div>
    </Fragment>
  );
};

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return { trainingPrograms: state.trainingPrograms.list };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedTP: () => {
      return dispatch(trainingProgramsActionCreators.setSelectedTraiingProgramGuid());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrainingProgramIndex);

